(function() {
	'use strict';

	(function() {
		const originalFetch = window.fetch;
		const interceptors = [];

		/**
		 * Register a new interceptor callback.
		 * Each callback receives (url, options) and must return [url, options].
		 */
		window.registerFetchInterceptor = function(callback) {
			if (typeof callback === "function") {
			interceptors.push(callback);
			}
		};

		// Override fetch
		window.fetch = async function(url, options) {
			let newUrl = url;
			let newOptions = options || {};

			// Run through all interceptors in order
			for (const interceptor of interceptors) {
			try {
				const result = interceptor(newUrl, newOptions);
				if (Array.isArray(result) && result.length === 2) {
				newUrl = result[0];
				newOptions = result[1];
				}
			} catch (err) {
				console.warn("Fetch interceptor error:", err);
			}
			}

			// Call the original fetch with the final modified request
			return originalFetch.call(this, newUrl, newOptions);
		};
	})();
    
	if (location.pathname.indexOf('/products/redsalt-elite-1') !== -1)
		location.href = '/products/redsalt-elite';
	
	function waitForEl(sel, cb, doc = document) {
		const inter = setInterval(function() {
			const el = doc.querySelector(sel);
			if (el) {
				clearInterval(inter);
				cb(el);
			}
		}, 100);
	}


	const option = `
	<div class="kaching-bundles__bar" data-otp-bar>
		<input type="radio" name="kaching-bundles-deal-3100a848def858" value="OTP" id="OTP"> 
		<label for="OTP" class="kaching-bundles__bar-container kaching-bundles__bar-container--most-popular kaching-bundles__bar-container--most-popular--simple">
			<div class="kaching-bundles__bar-wrapper">
				<div role="button" tabindex="0" class="kaching-bundles__bar-main">
					<div class="kaching-bundles__bar-radio"></div>
					<div class="kaching-bundles__bar-content">
						<div class="kaching-bundles__bar-content-left">
							<div class="kaching-bundles__bar-first-line">
								<span class="kaching-bundles__bar-title">1 Bag/One Time Purchase</span>
							</div>
						</div>
						<div class="kaching-bundles__bar-pricing">
							<div class="kaching-bundles__bar-price"></div>
						</div>
					</div>
				</div>
				<div class="kaching-bundles__bar-variants">
					<div class="kaching-bundles__bar-variant-names"><span>Flavor</span></div>
					<div class="kaching-bundles__bar-variant-selector-wrapper">
						<div class="kaching-bundles__bar-variant">
							<div class="kaching-bundles__bar-variant__content">
								<div class="kaching-bundles__bar-variant-selects">
									<div class="kaching-bundles__swatch-dropdown kaching-bundles-option" data-name="Flavor">
										<span role="button" tabindex="0" class="kaching-bundles__bar-variant-select" onclick="openSelect(this)">
											<div class="kaching-bundles__swatch" style="--kaching-swatch-size: 16px; --kaching-swatch-border-radius: 20%;--kaching-swatch-color: rgba(228, 69, 69, 1);"></div>
											<span>Hawaiian Watermelon</span>
										</span>
										<div class="kaching-bundles__swatch-dropdown__options" style="display: none;">
											<span role="button" tabindex="0" class="kaching-bundles__swatch-dropdown__option kaching-bundles-option-value" onclick="selectFlavor(this, 'Hawaiian Watermelon', '#cd3e3e')">
												<div class="kaching-bundles__swatch" style="--kaching-swatch-size: 21.994px; --kaching-swatch-border-radius: 20%; --kaching-swatch-color: rgba(228, 69, 69, 1); --kaching-swatch-border-color: rgba(205, 62, 62, 1);"></div>
												<span>Hawaiian Watermelon</span>
											</span>
											<span role="button" tabindex="0" class="kaching-bundles__swatch-dropdown__option kaching-bundles-option-value" onclick="selectFlavor(this, 'Hawaiian Citrus', '#ffffff')">
												<div class="kaching-bundles__swatch" style="--kaching-swatch-size: 21.994px; --kaching-swatch-border-radius: 20%;"></div>
												<span>Hawaiian Citrus</span>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</label>
	</div>
	<style>.kaching-bundles__subscriptions, variant-dropdown {display: none !important}</style>
	`;
	window.OTPFlavor = "51093069594941";
	window.openSelect = function (select) {
		select = select.parentNode;
		select.classList.add('opened');
		select.querySelector('.kaching-bundles__swatch-dropdown__options').style.display = 'flex';
	}

	window.createFOD = function(form) {
		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				attributes: {
					Firstorderdate: FirstOrderDate
				}
			})
		})
	};

	window.selectFlavor = function(option, flavor, color) {
		const form = document.querySelector('product-form form');
		const ids = {
			"Hawaiian Watermelon": "51093069594941", //watermelon
			"Hawaiian Citrus": "51093069627709" // citrus
		};

		window.OTPFlavor = ids[flavor] || "51093069594941";
		const dropdown = option.closest('.kaching-bundles__swatch-dropdown');
		if (dropdown) {
			dropdown.querySelector('.kaching-bundles__swatch-dropdown__options').style.display = 'none';
			dropdown.querySelector('.kaching-bundles__bar-variant-select span').innerText = flavor;
			dropdown.querySelector('.kaching-bundles__bar-variant-select div').style.setProperty('--kaching-swatch-color', color);
		}
		const id = form.querySelector('[name="id"]');
		id.value = ids[flavor];
		
		createFOD(form);
	}


	waitForEl('.kaching-bundles__bars', function(el) {
		
		const ids = {
			"51015142474045": "51093069594941", //watermelon
			"51015142506813": "51093069627709" // citrus
		};
		
		if (location.pathname.indexOf('/products/redsalt-elite') === -1 && location.pathname.indexOf('/pages/redsalt-elite-experience') === -1) 
			return;
			
		const form = document.querySelector('product-form form');
		const firstBarInput = el.querySelector('.kaching-bundles__bar input');
		const firstBarPrice = el.querySelector('.kaching-bundles__bar-full-price');
		
		createFOD(form);

		if (location.pathname.indexOf('/pages/redsalt-elite-experience') !== -1) {
			registerFetchInterceptor((url, options) => {
				if (url === '/cart/add.js') {
					const data = JSON.parse(options.body);
					if (data.items) {
						if (data.items.length === 1) {
							data.items[0].id = window.OTPFlavor;
							delete data.items[0].selling_plan;
							delete data.items[0].properties;
							options.body = JSON.stringify(data)
							return [url, options];
						}
					}
				}
				return [url, options];
			})
		}
		
		el.insertAdjacentHTML("beforeend", option);
		
		const otpBarInput = el.querySelector('.kaching-bundles__bar[data-otp-bar] input');
		const otpBarPrice = el.querySelector('.kaching-bundles__bar[data-otp-bar] .kaching-bundles__bar-price');
		otpBarInput.name = firstBarInput.name;
		otpBarPrice.innerText = firstBarPrice.innerText;
		
		document.addEventListener('change', e => {
			if (e.target.name !== firstBarInput.name) return;
			
			if (!e.target.closest('[data-otp-bar]')) {
				el.querySelector('[data-otp-bar]').classList.remove('kaching-bundles__bar--selected');

				setTimeout(function() {
					const kb = form.querySelector('[name="properties[__kaching_bundles]"]');
					if (kb)
						kb.removeAttribute('disabled');
					const sp = form.querySelector('[name="selling_plan"]');
					if (sp)
						sp.removeAttribute('disabled');

					createFOD(form);

				}, 500)
			} else if(e.target.closest('[data-otp-bar]') && e.target.checked) {
				el.querySelector('[data-otp-bar]').classList.add('kaching-bundles__bar--selected');
				el.querySelector('.kaching-bundles__bar--selected[data-deal-bar-id] [role="button"]').click();

				setTimeout(() => {
					const sp = form.querySelector('[name="selling_plan"]');
					if (sp)
						sp.value = '';

					const kb = form.querySelector('[name="properties[__kaching_bundles]"]');
					if (kb)
						kb.value = '';
					const val = ids[id.value];
					
					createFOD(form);
					id.value = val;
				}, 500);
			}
		});
	});
})();